require('../../modules/es6.symbol');
require('../../modules/es6.object.to-string');
module.exports = require('../../modules/$.core').Symbol;


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/fn/symbol/index.js
// module id = 1891
// module chunks = 0